// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"400":"6d06fb7c","532":"d970554a","957":"3e1031cc"}[chunkId] + ".chunk.css";
};